import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import "./Brand.css";
import InnerBanner from "../components/InnerBanner";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const isLocalHost =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

const defaultBaseUrl = isLocalHost
  ? "http://localhost:5001"
  : "https://api.customersupports24x7.in";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || defaultBaseUrl;

const brandRoutes = {
  lg: "/lg-appliance-service-bangalore",
  samsung: "/samsung-appliance-repair-bangalore",
  ifb: "/ifb-appliance-repair-bangalore",
  whirlpool: "/whirlpool-appliance-repair-bangalore",
  bosch: "/bosch-appliance-repair-bangalore",
};

export default function Brands() {
  const [brands, setBrands] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchBrands();
  }, []);

  const fetchBrands = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/brands`);
      setBrands(res.data);
    } catch (err) {
      console.log("Error fetching brands:", err);
    }
  };

  const handleBrandClick = (brandName) => {
    const normalizedName = String(brandName || "").trim().toLowerCase();
    
    // Try direct match first
    if (brandRoutes[normalizedName]) {
      navigate(brandRoutes[normalizedName]);
      return;
    }
    
    // Extract base name (remove numbers, e.g., "lg1" -> "lg")
    const baseNameMatch = normalizedName.match(/^[a-z]+/);
    const baseName = baseNameMatch ? baseNameMatch[0] : normalizedName;
    
    if (brandRoutes[baseName]) {
      navigate(brandRoutes[baseName]);
      return;
    }
    
    // Fallback
    navigate(`/models/${brandName}`);
  };

  return (
    <>
      <Helmet>
        <title>Brands page | All Brands in Bangalore</title>
        <meta
          name="description"
          content="We provide expert appliance repair services for LG, Samsung, IFB, Whirlpool, Bosch, and other brands in Bangalore."
        />
        <meta
          name="keywords"
          content="appliance brands bangalore, appliance repair services in Bangalore"
        />
        <meta property="og:title" content="Brands page | All Brands in Bangalore" />
        <meta
          property="og:description"
          content="We provide expert appliance repair services for LG, Samsung, IFB, Whirlpool, Bosch, and other brands in Bangalore."
        />
        <meta property="og:image" content="https://customersupports24x7.in/customerSupport.png" />
        <meta property="og:url" content="https://customersupports24x7.in/brands" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Brands page | All Brands in Bangalore" />
        <meta
          name="twitter:description"
          content="We provide expert appliance repair services for LG, Samsung, IFB, Whirlpool, Bosch, and other brands in Bangalore."
        />
        <meta name="twitter:image" content="https://customersupports24x7.in/customerSupport.png" />
        <link rel="canonical" href="https://customersupports24x7.in/brands" />
      </Helmet>
      <InnerBanner title="Brands" />

      <div className="brands-page-root">
        <div className="tech-dots-bg"></div>

        <header className="brands-header">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <span className="badge-pill" style={{ fontSize: "20px" }}>
              Certified Service Centers
            </span>

            <br />
            <br />

            <p className="subtitle">
              We provide authorized-grade repair for global appliance leaders
            </p>
          </motion.div>
        </header>

        {/* DYNAMIC GRID */}
        <section className="brands-bento-grid">
          {brands.map((brand) => (
            <motion.div
              key={brand._id}
              className="bento-card"
              whileHover={{ y: -8 }}
              onClick={() => handleBrandClick(brand.name)}
              style={{ cursor: "pointer" }}
            >
              <div className="brand-logo-container">
                <img src={brand.logo} alt={brand.name} />
              </div>

              <div className="brand-content">
                <h3>{brand.name}</h3>

                <p>Specialized {brand.name} Support</p>

                <span className="arrow-btn">
                  View Details →
                </span>
              </div>
            </motion.div>
          ))}
        </section>
      </div>
    </>
  );
}
